// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  Grid,
  CircularProgress,
  Alert,
} from "@mui/material";
import PropTypes from "prop-types";
import KeyCloak from "../Auth/Keycloak";
import { DifusionesListas } from "./DifusionesListas";
import { DifusionesConsulta } from "./DifusionesConsulta";
import { DifusionesDashboard } from "./DifusionesDashboard";
import { ProvideAreas } from "../Areas/State/ProvideAreas";
import { ProvideAlias } from "../Alias/State/ProvideAlias";
import { useAuth } from "../Auth/State/AuthContext";
import { useDifusiones } from "./context/DifusionesContext";
import { useBody } from "../Body/state/BodyContext";

function TabPanel(props) {
  const { children, value, index, dir } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      dir={dir}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export const Difusiones = () => {

  const { obtenerAreas } = useDifusiones();
  const { setMessage } = useBody();
  const { hasRole } = useAuth();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const tabs = [
    { label: "Difusiones", component: <DifusionesConsulta /> },
    { label: "Listas", component: <DifusionesListas /> },
    // {
    //   label: "Dashboard",
    //   component: (
    //     <DifusionesDashboard
    //       admin={hasRole(["ROLE_OBTENER_TODAS_DIFUSIONES"])}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    async function fetchAreas() {
      setLoading(true);
      try {
        await obtenerAreas();
      } catch (error) {
        console.error("Error al obtener áreas:", error);
        setMessage("Hubo un error al traer las areas del usuario");
      } finally {
        setLoading(false);
      }
    }

    if (KeyCloak.hasRole(["ROLE_OBTENER_AREAS", "ROLE_OBTENER_ALIAS"])) {
      fetchAreas();
    } else {
      setMessage("Usted no posee permisos para obtener las Areas y/o los Alias");
      setLoading(false);
    }

  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ProvideAreas>
      <ProvideAlias>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff",
            padding: { xs: "0px", md: "1.25%" },
          }}
        >
          <Grid
            container
            direction="column"
            sx={{
              justifyContent: "space-between",
              alignItems: "stretch",
            }}
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  marginTop: "-24px",
                  width: "100%",
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="fullWidth"
                  textColor="primary"
                  indicatorColor="primary"
                >
                  {tabs.map((tab, index) => (
                    <Tab
                      key={index}
                      label={tab.label}
                      id={`tab-${index}`}
                      aria-controls={`tabpanel-${index}`}
                      sx={{
                        marginTop: matches ? "30px" : "10px",
                        paddingBottom: "17.5px",
                      }}
                    />
                  ))}
                </Tabs>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Alert severity="info" sx={{ mt: 1, mb: 0.5 }}>
                <strong>Actualización en Difusiones.</strong> El sistema ahora opera hasta
                cinco veces más rápido que antes. Si detecta algún inconveniente, por favor
                comuníquese con el <strong>equipo de soporte</strong>.
              </Alert>
            </Grid>
            {loading ? (
              <Box style={{ display: 'flex', justifyContent: 'center', height: '50vh', alignItems: 'center' }}>
                <CircularProgress />
              </Box>
            ) : (
              <Grid item xs={12}>
                {
                  KeyCloak.hasRole(["ROLE_OBTENER_ALIAS"]) &&
                    KeyCloak.hasRole(["ROLE_OBTENER_AREAS"]) ? (
                    <Box>
                      {tabs.map((tab, index) => (
                        <TabPanel
                          key={index}
                          value={value}
                          index={index}
                          dir={theme.direction}
                        >
                          {tab.component}
                        </TabPanel>
                      ))}
                    </Box>
                  ) : null
                }
              </Grid>
            )}
          </Grid>
        </Box>
      </ProvideAlias>
    </ProvideAreas>
  );
};
